import { apiCall } from "./service";
import { BASE_URL } from "./URL";

const resourcesReportApi = {
  getReport(filters = {}) {
    const params = new URLSearchParams();

    if (filters.clientId) params.append("ClientId", filters.clientId);
    if (filters.portfolioId) params.append("PortfolioId", filters.portfolioId);
    if (filters.programId) params.append("ProgramId", filters.programId);
    if (filters.projectId) params.append("ProjectId", filters.projectId);
    if (filters.startDate) params.append("StartDate", filters.startDate);
    if (filters.endDate) params.append("EndDate", filters.endDate);
    if (filters.resources?.length) params.append("Resources", filters.resources.join(","));

    const query = params.toString();
    const url = `${BASE_URL}resources/report${query ? `?${query}` : ""}`;

    return apiCall.get({ url, isAuthToken: true });
  },

  // --- Lookup endpoints for filters ---

  searchClients(searchTerm = "") {
    const params = new URLSearchParams();
    if (searchTerm) params.append("searchTerm", searchTerm);
    const url = `${BASE_URL}search/Clients${params.toString() ? `?${params}` : ""}`;
    return apiCall.get({ url, isAuthToken: true });
  },

  searchPortfolios(searchTerm = "", { clientId } = {}) {
    const params = new URLSearchParams();
    if (searchTerm) params.append("searchTerm", searchTerm);
    if (clientId) params.append("clientId", clientId);
    const url = `${BASE_URL}search/client-portfolios${params.toString() ? `?${params}` : ""}`;
    return apiCall.get({ url, isAuthToken: true });
  },

  searchPrograms(searchTerm = "", { portfolioId, clientId } = {}) {
    const params = new URLSearchParams();
    if (searchTerm) params.append("searchTerm", searchTerm);
    if (portfolioId) params.append("portfolioId", portfolioId);
    if (clientId) params.append("clientId", clientId);
    const url = `${BASE_URL}search/client-programs${params.toString() ? `?${params}` : ""}`;
    return apiCall.get({ url, isAuthToken: true });
  },

  searchProjects(searchTerm = "", { clientId, portfolioId, programId } = {}) {
    const params = new URLSearchParams();
    if (searchTerm) params.append("searchTerm", searchTerm);
    if (clientId) params.append("clientId", clientId);
    if (portfolioId) params.append("portfolioId", portfolioId);
    if (programId) params.append("programId", programId);
    const url = `${BASE_URL}search/projects${params.toString() ? `?${params}` : ""}`;
    return apiCall.get({ url, isAuthToken: true });
  },
};

export default resourcesReportApi;
